// extracted by mini-css-extract-plugin
export var brandInput = "brand-field-array-module--brand-input--2780d";
export var buttonAdd = "brand-field-array-module--button-add--dd9e2";
export var buttonAddInner = "brand-field-array-module--button-add-inner--e24ce";
export var container = "brand-field-array-module--container--ad94b";
export var deleteBox = "brand-field-array-module--delete-box--a67ae";
export var deleteButton = "brand-field-array-module--delete-button--23b3f";
export var field = "brand-field-array-module--field--31a3f";
export var ownerInput = "brand-field-array-module--owner-input--6c4dd";